import React from 'react';
import { Link } from 'react-router-dom';
import { Phone, Mail, ExternalLink } from 'lucide-react';
import { useCMS } from '../../context/CMSContext';

const LOGO_URL = 'https://customer-assets.emergentagent.com/job_c8eaf99c-4f2a-48e9-9fc0-504e56c7d156/artifacts/yqk618vz_WhatsApp_Image_2025-10-17_at_11.26.30-removebg-preview.png';

export const HomeFooter = () => {
  const cms = useCMS();
  const footer = cms?.footer || {};
  const contactPersons = footer.contact_persons || [];
  const deptEmails = footer.department_emails || [];

  return (
    <footer id="contact" className="bg-slate-900 dark:bg-black border-t border-slate-800 dark:border-white/5 pt-20 pb-10" data-testid="footer">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid md:grid-cols-4 gap-12 mb-16">
          <div>
            <div className="flex items-center gap-4 mb-6"><img src={LOGO_URL} alt="Tridev Logistics" className="h-12 w-auto" /><h2 className="font-outfit text-3xl font-black text-white">TRIDEV</h2></div>
            <p className="text-slate-400 max-w-md mb-6 leading-relaxed">{footer.company_description || "India's trusted logistics partner."}</p>
          </div>
          <div>
            <h3 className="font-outfit text-white font-bold text-lg mb-6">Contact Us</h3>
            <div className="space-y-5">
              {contactPersons.map(person => (
                <div key={person.phone}>
                  <p className="font-semibold text-white text-sm">{person.name}</p>
                  <p className="text-slate-400 text-sm mb-2">+91 {person.phone}</p>
                  <div className="flex gap-2">
                    <a href={`tel:+91${person.phone}`} className="px-3 py-1 bg-blue-600 text-white text-xs font-bold rounded-lg hover:bg-blue-700 flex items-center gap-1"><Phone className="w-3 h-3" />Call</a>
                    <a href={`https://wa.me/91${person.phone}`} target="_blank" rel="noopener noreferrer" className="px-3 py-1 bg-green-600 text-white text-xs font-bold rounded-lg hover:bg-green-700 flex items-center gap-1"><ExternalLink className="w-3 h-3" />WhatsApp</a>
                    <a href={`mailto:${person.email}`} className="px-3 py-1 bg-amber-600 text-white text-xs font-bold rounded-lg hover:bg-amber-700 flex items-center gap-1"><Mail className="w-3 h-3" />Email</a>
                  </div>
                </div>
              ))}
            </div>
          </div>
          <div>
            <h3 className="font-outfit text-white font-bold text-lg mb-6">Department Emails</h3>
            <ul className="space-y-3 text-slate-400 text-sm">
              {deptEmails.map(dept => (
                <li key={dept.email}><span className="block text-xs text-slate-500 mb-0.5">{dept.label}</span><a href={`mailto:${dept.email}`} className="hover:text-amber-500 transition-colors">{dept.email}</a></li>
              ))}
            </ul>
          </div>
          <div>
            <h3 className="font-outfit text-white font-bold text-lg mb-6">Quick Links</h3>
            <ul className="space-y-3">
              <li><Link to="/" className="text-slate-400 hover:text-amber-500 transition-colors">Home</Link></li>
              <li><a href="#services" className="text-slate-400 hover:text-amber-500 transition-colors">Services</a></li>
              <li><a href="#how-it-works" className="text-slate-400 hover:text-amber-500 transition-colors">How It Works</a></li>
              <li><Link to="/login" className="text-slate-400 hover:text-amber-500 transition-colors">Login</Link></li>
            </ul>
          </div>
        </div>
        <div className="border-t border-slate-800 pt-8 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-slate-500 text-sm">&copy; 2026 Tridev Logistics. All rights reserved.</p>
          <div className="flex gap-6 text-sm text-slate-500">
            <a href="#" className="hover:text-amber-500 transition-colors">Privacy Policy</a>
            <a href="#" className="hover:text-amber-500 transition-colors">Terms of Service</a>
          </div>
        </div>
      </div>
    </footer>
  );
};
